var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNgoinha(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 666,
    height: 480,
    viewBox: "0 0 666 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.553 479.302V456.886L665.936 276.324V298.4L351.553 479.302Z",
    fill: "url(#paint0_linear_413_3712)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1556 276.075L351.554 456.885V479.301L37.1556 298.492V276.075Z",
    fill: "url(#paint1_linear_413_3712)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M351.554 95.3908L665.936 276.2L351.554 456.761L37.1556 275.952L351.554 95.3908Z",
    fill: "#D9DFE6",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M337.032 372.62L351.662 456.793L0.226562 258.023L344.023 199.5L337.032 372.62Z",
    fill: "url(#paint2_linear_413_3712)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.366 280.195V139.973L336.916 47.1838V187.235L175.366 280.195Z",
    fill: "url(#paint3_linear_413_3712)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M336.916 373.109V232.887L498.466 140.098V280.149L336.916 373.109Z",
    fill: "#D9DFE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.366 139.974L336.916 232.887V373.109L175.366 280.195V139.974Z",
    fill: "#C6CED9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M336.916 47.1838L498.466 140.097L336.916 232.886L175.366 139.973L336.916 47.1838Z",
    fill: "#D9DFE6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.366 139.974L255.854 0.293945L411.25 89.9398L336.916 232.887L175.366 139.974Z",
    fill: "#C6CED9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M455.364 215.001V262.805L400.219 294.535V246.669L447.797 219.352L455.364 215.001Z",
    fill: "url(#paint4_linear_413_3712)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M447.797 221.202V260.969L400.219 288.332V248.519L447.797 221.202Z",
    fill: "url(#paint5_linear_413_3712)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M436.181 141.959C436.181 151.59 429.273 163.344 420.761 168.19C414.93 171.514 409.851 170.733 407.231 166.808C406.032 165.006 405.341 162.543 405.341 159.52C405.341 149.888 412.249 138.155 420.761 133.309C424.499 131.187 427.933 130.726 430.594 131.727C434.007 132.969 436.181 136.553 436.181 141.959Z",
    fill: "url(#paint6_linear_413_3712)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M432.622 139.144C432.622 148.934 425.7 160.862 417.124 165.787C413.366 167.945 409.915 168.413 407.24 167.395C406.035 165.563 405.341 163.06 405.341 159.986C405.341 150.196 412.284 138.269 420.84 133.344C424.597 131.186 428.048 130.718 430.723 131.736C431.928 133.567 432.622 136.071 432.622 139.144Z",
    fill: "url(#paint7_linear_413_3712)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M260.112 82.6313L200.508 96.3515L222.774 57.715L280.047 41.4707L260.112 82.6313Z",
    fill: "url(#paint8_linear_413_3712)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M259.505 83.5922V53.2715L280.047 41.4715L259.505 83.5922Z",
    fill: "url(#paint9_linear_413_3712)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M238.965 41.457L259.506 53.2725V83.5932L238.965 71.7932V41.457Z",
    fill: "#A0AEC0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M259.506 29.6562L280.047 41.4717L259.506 53.2717L238.965 41.4562L259.506 29.6562Z",
    fill: "url(#paint10_linear_413_3712)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M259.505 32.8781L274.437 41.4726L259.505 50.0516L244.557 41.4571L259.505 32.8781Z",
    fill: "url(#paint11_linear_413_3712)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M259.505 32.8781V50.0516L244.557 41.4571L259.505 32.8781Z",
    fill: "url(#paint12_linear_413_3712)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M257.393 359.25V166.771L319.273 131.24L286.203 203.525L285.161 343.414L257.393 359.25Z",
    fill: "url(#paint13_linear_413_3712)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M195.498 131.178L257.393 166.77V359.25L195.498 323.658V131.178Z",
    fill: "url(#paint14_linear_413_3712)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M229.91 287.804C218.863 281.823 210.058 269.883 210.245 261.141L211.076 220.648L251.049 242.307L250.219 282.799C250.052 291.541 240.957 293.784 229.91 287.804Z",
    fill: "#0C4180"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M240.999 247.394L251.05 242.306L246.128 290.088L235.683 295.362L240.999 247.394Z",
    fill: "#0C4180"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M219.86 292.89C208.813 286.91 200.008 274.991 200.195 266.228L201.026 225.735L240.999 247.393L240.189 287.886C240.002 296.628 230.928 298.871 219.881 292.89H219.86Z",
    fill: "#1B85F3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M201.025 225.736L211.075 220.648L251.049 242.307L240.998 247.394L201.025 225.736Z",
    fill: "#1268CC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M218.381 228.244C218.235 228.888 216.699 229.096 214.954 228.681C213.21 228.286 211.923 227.435 212.068 226.77C212.213 226.126 213.75 225.919 215.494 226.334C217.239 226.729 218.526 227.58 218.381 228.244Z",
    fill: "#0C4180"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M215.494 227.019C216.844 227.33 217.924 227.912 218.256 228.452C218.319 228.389 218.36 228.306 218.36 228.244C218.505 227.6 217.218 226.749 215.474 226.334C213.729 225.939 212.193 226.126 212.047 226.77C212.006 226.915 212.047 227.081 212.172 227.227C212.587 226.749 213.958 226.645 215.474 226.998L215.494 227.019Z",
    fill: "#74B4FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M241.141 239.969C240.996 240.613 239.459 240.82 237.715 240.405C235.971 240.011 234.683 239.159 234.829 238.495C234.974 237.851 236.511 237.643 238.255 238.059C239.999 238.453 241.287 239.305 241.141 239.969Z",
    fill: "#0C4180"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M238.255 238.744C239.605 239.055 240.684 239.636 241.017 240.176C241.079 240.114 241.12 240.031 241.12 239.969C241.266 239.325 239.978 238.474 238.234 238.058C236.49 237.664 234.953 237.851 234.808 238.494C234.766 238.64 234.808 238.806 234.932 238.951C235.348 238.474 236.718 238.37 238.234 238.723L238.255 238.744Z",
    fill: "#74B4FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M240.871 218.696C240.871 211.242 235.078 202.188 227.706 198.056C223.74 195.834 219.795 195.398 216.908 196.851C214.167 198.242 212.651 201.108 212.651 204.929V227.044C212.651 227.605 213.876 228.311 215.392 228.602C216.908 228.892 218.113 228.664 218.113 228.103V205.988C218.113 203.995 218.798 202.562 220.023 201.939C221.414 201.233 223.532 201.565 225.817 202.832C231.008 205.739 235.389 212.508 235.389 217.637V238.756H235.431C235.431 238.756 235.389 238.818 235.389 238.839C235.389 239.4 236.615 240.106 238.13 240.396C239.646 240.687 240.871 240.459 240.871 239.898C240.871 239.856 240.83 239.836 240.83 239.794H240.871V218.676V218.696Z",
    fill: "url(#paint15_linear_413_3712)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M223.992 261.286C225.009 260.87 225.632 259.853 225.632 258.316C225.632 255.284 223.161 251.38 220.129 249.636C217.098 247.871 214.627 248.93 214.627 251.962C214.627 253.748 215.478 255.803 216.786 257.569C216.911 257.755 216.973 257.963 216.932 258.192L214.793 271.066C214.73 271.419 214.897 271.751 215.208 271.938L224.054 277.192C224.656 277.566 225.425 277.047 225.321 276.34L223.369 262.199C223.307 261.784 223.597 261.431 223.992 261.265V261.286Z",
    fill: "#0C4180"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M218.946 272.707C218.634 272.52 218.489 272.187 218.53 271.834L220.669 258.96C220.711 258.731 220.648 258.524 220.503 258.337C219.195 256.572 218.343 254.516 218.343 252.73C218.343 251.11 219.07 250.072 220.191 249.719C220.171 249.719 220.129 249.678 220.108 249.657C217.077 247.892 214.606 248.951 214.606 251.983C214.606 253.768 215.457 255.824 216.765 257.589C216.89 257.776 216.952 257.984 216.911 258.212L214.772 271.087C214.709 271.44 214.876 271.772 215.187 271.959L224.033 277.213C224.615 277.566 225.279 277.13 225.3 276.486L218.946 272.707Z",
    fill: "#74B4FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M257.393 95.6317L319.273 131.239L257.393 166.77L195.498 131.177L257.393 95.6317Z",
    fill: "url(#paint16_linear_413_3712)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_413_3712",
    x1: 487.108,
    y1: 288.542,
    x2: 524.656,
    y2: 438.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0AEC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_413_3712",
    x1: 37.1556,
    y1: 374.13,
    x2: 351.554,
    y2: 374.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0AEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BECD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_413_3712",
    x1: 315.971,
    y1: 289.129,
    x2: 64.5222,
    y2: 333.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_413_3712",
    x1: 175.366,
    y1: 163.697,
    x2: 336.916,
    y2: 163.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8256EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B28AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_413_3712",
    x1: 400.219,
    y1: 254.768,
    x2: 455.364,
    y2: 254.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0AEC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_413_3712",
    x1: 400.219,
    y1: 254.759,
    x2: 447.797,
    y2: 254.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B85F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#429FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_413_3712",
    x1: 405.341,
    y1: 150.749,
    x2: 436.181,
    y2: 150.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0AEC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_413_3712",
    x1: 405.341,
    y1: 149.561,
    x2: 432.622,
    y2: 149.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B85F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#429FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_413_3712",
    x1: 278.028,
    y1: 41.4627,
    x2: 220.882,
    y2: 86.6216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0AEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_413_3712",
    x1: 259.505,
    y1: 62.5319,
    x2: 280.047,
    y2: 62.5319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808B9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CED9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_413_3712",
    x1: 238.965,
    y1: 41.4562,
    x2: 280.047,
    y2: 41.4562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3BECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606873"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_413_3712",
    x1: 244.557,
    y1: 41.4571,
    x2: 274.437,
    y2: 41.4571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_413_3712",
    x1: 244.557,
    y1: 41.4571,
    x2: 259.505,
    y2: 41.4571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#808B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_413_3712",
    x1: 257.393,
    y1: 245.238,
    x2: 319.273,
    y2: 245.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0AEC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_413_3712",
    x1: 195.498,
    y1: 245.221,
    x2: 257.393,
    y2: 245.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BECD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_413_3712",
    x1: 216.709,
    y1: 213.116,
    x2: 249.733,
    y2: 211.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3BECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0AEC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_413_3712",
    x1: 195.498,
    y1: 131.208,
    x2: 319.273,
    y2: 131.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CED9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0AEC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgoinha);
export default __webpack_public_path__ + "static/media/ngoinha.91c28324e7d625c4184d19dbabb9ae52.svg";
export { ForwardRef as ReactComponent };